export default "__VITE_ASSET__pMHjwkQ1__"